import * as z from "zod/v4";

export const getLegacySignedOAuthState = {
  name: "getLegacySignedOAuthState" as const,
  input: z.object({}),
  output: z.object({ teamId: z.string(), signedState: z.string() }),
};
